import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { Hooks } from "@grandvisionhq/payments";
import { useFeatureToggles } from "@grandvisionhq/state";
import { REMOVE_CART_LINE_ITEMS } from "../../../../../../../../operations/mutations/operations/mutations/remove-cart-line-items.js";
import { GET_CART } from "../../../../../../../../operations/queries/operations/queries/get-cart.js";
const FixCartButtonContainer = ({
  unavailableLineItems,
  labels,
  handleCheckoutNavigation,
  isLoggedIn
}) => {
  const [{ cartId, cartHash }, { setCartCount }] = useCartStorage();
  const { isLoggedInExpressCheckoutEnabled } = useFeatureToggles();
  const { href: hrefWithCartId } = Hooks.useGoToCheckoutLink(
    cartId,
    cartHash,
    isLoggedInExpressCheckoutEnabled && isLoggedIn
  );
  const unavailableItemIds = unavailableLineItems?.map(({ id }) => ({ id }));
  const hasUnavailableItems = unavailableItemIds?.length;
  const [removeCartItems, { loading }] = useMutation(REMOVE_CART_LINE_ITEMS, {
    onCompleted: (data) => {
      if (!data.removeCartLineItems.cart?.lineItems.length) {
        setCartCount(0);
        return;
      } else {
        setCartCount(data.removeCartLineItems.cart?.numberOfItems);
      }
      handleCheckoutNavigation && handleCheckoutNavigation();
      window.location.href = hrefWithCartId;
    },
    update(cache, { data }) {
      if (data && data.removeCartLineItems.success === true) {
        const newCart = data.removeCartLineItems.cart;
        cache.writeQuery({
          query: GET_CART,
          variables: { id: cartId },
          data: {
            cart: {
              cart: newCart,
              validationErrors: null,
              failures: null
            }
          }
        });
        window.scrollTo(0, 0);
      }
    }
  });
  const removeAndNavigate = React.useCallback(
    (e) => {
      if (hasUnavailableItems && cartId) {
        e.preventDefault();
        removeCartItems({
          variables: {
            cartInput: {
              cartId,
              lineItems: unavailableItemIds
            }
          }
        });
      }
    },
    [removeCartItems, cartId, unavailableItemIds, hasUnavailableItems]
  );
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      isLoading: loading,
      className: "cart-navigation__button",
      "data-t": "cart-go-to-checkout",
      caption: labels.goToCheckout,
      href: hrefWithCartId,
      "data-element-id": "Summary_Checkout",
      "data-description": isLoggedInExpressCheckoutEnabled && isLoggedIn ? "express_checkout_loggedin" : "regular_checkout_guest",
      onClick: hasUnavailableItems ? removeAndNavigate : handleCheckoutNavigation
    }
  );
};
export {
  FixCartButtonContainer
};
//# sourceMappingURL=FixCartButtonContainer.js.map
